import {
    AHOC_UPLOAD_DOCUMENTS_ADD_FIRE_REPORT,
    AHOC_UPLOAD_DOCUMENTS_ADD_TECHNICAL_REPORT,
    AHOC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT,
    AHOC_UPLOAD_DOCUMENTS_RESET,
    AHOC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE,
    AHOC_UPLOAD_DOCUMENTS_SET_VALID,
    AHOC_UPLOAD_DOCUMENTS_SET_VALUE,
} from '../../actions/allsureHomeClaim/uploadDocuments';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initUploadDocument = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        certifiedCopyOfId: { fileName: null, fileContaint: null, error: null, status: FORM_STATUS.valid, file: null },
        policeReport: { fileName: null, fileContaint: null, error: null, status: FORM_STATUS.valid, file: null },
        repairQuotes: { fileName: null, fileContaint: null, error: null, status: FORM_STATUS.valid, file: null },
    },
};

export default (state = initUploadDocument, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case AHOC_UPLOAD_DOCUMENTS_SET_VALUE:
            const { inputType, fileName, fileContaint, file } = action.value;
            return updateFormField(inputType, (field) => ({
                ...field,
                fileName: fileName,
                fileContaint: fileContaint,
                file: file,
            }));

        case AHOC_UPLOAD_DOCUMENTS_SET_VALID:
            return updateFormField(action.fileType, (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case AHOC_UPLOAD_DOCUMENTS_ADD_TECHNICAL_REPORT:
            return {
                ...state,
                form: {
                    ...state.form,
                    technicalReport: { fileName: null, fileContaint: null, error: null, status: null, file: null },
                    },
            };

        case AHOC_UPLOAD_DOCUMENTS_ADD_FIRE_REPORT:
            return {
                ...state,
                form: {
                    ...state.form,
                    fireReport: { fileName: null, fileContaint: null, error: null, status: null, file: null },
                    },
            };
        case AHOC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT:
            return {
                ...state,
                form: {
                    ...state.form,
                    [`additionalDocument_${Object.keys(state.form).length}`]: {
                        fileName: null,
                        fileContaint: null,
                        error: null,
                        status: null,
                        file: null,
                        dependentValue: null,
                        dependentField: `additionalDocument_${Object.keys(state.form).length}`,
                        validationCondition: (currentfield, dependentField) =>!!dependentField.fileName
                    },
                },
            };

        case AHOC_UPLOAD_DOCUMENTS_RESET:
            return { ...state, form: initUploadDocument.form };

        case AHOC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE:
            const existingForm = {
                ...state.form,
            };
            action?.value?.forEach((item) => {
                const documentNameKey = item.documentName;
                if (existingForm[documentNameKey]) {
                    existingForm[documentNameKey].url = item.url;
                }
            });
            return { ...state, form: existingForm };

        default:
            return state;
    }
};
